import flagsmith from 'flagsmith/isomorphic';
import { FEATURE_FLAGS } from '../featuresWrapper/flags';
import { migratedApiRoutes } from '../../../server/config/msApiRoutesConfig';
import getEnvVar from '../../lib/envvars';

export const DslMigration = (endpoint, options = {}) => {
  const isDslV2On = flagsmith.hasFeature(FEATURE_FLAGS?.V2_ENDPOINTS_FMBS_580);

  if (isDslV2On) {
    const url = new URL(endpoint);
    const { pathname } = url; // e.g. /api/v1/trade-in/price
    const queryStr = url.search; // includes '?' if present

    const matchedKey = findMatchingMigratedKey(pathname, options.method);
    if (matchedKey) {
      const baseUrl = getEnvVar('apiUrlDslV2');
      const endpointConfig = migratedApiRoutes[matchedKey];
      const dslPath = endpointConfig.url;

      return `${baseUrl}${dslPath}${queryStr}`;
    }
  }
  return endpoint;
};

function findMatchingMigratedKey(pathname, method) {
  return Object.keys(migratedApiRoutes).find(key => {
    const isPathMatch = pathname.includes(key);
    const isMethodMatch =
      migratedApiRoutes[key].method.toLowerCase() === method.toLowerCase();
    return isPathMatch && isMethodMatch;
  });
}
